import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { OpusAgentFieldsFragmentDoc } from '../opus-agent/agentPanel.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpusAgentTemplatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OpusAgentTemplatesQuery = { __typename?: 'Query', OpusAgentTemplates: Array<{ __typename?: 'OpusAgentTemplate', id: string, key: string, name: string, emoji: string, description: string, instructions: string, category: { __typename?: 'OpusAgentTemplateCategory', id: string, name: string, index: number } }> };

export type CreateOpusAgentFromTemplateMutationVariables = Types.Exact<{
  templateId: Types.Scalars['UUID']['input'];
}>;


export type CreateOpusAgentFromTemplateMutation = { __typename?: 'Mutation', createOpusAgentFromTemplate: { __typename?: 'OpusAgentResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, agent?: { __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null } | null } };


export const OpusAgentTemplatesDocument = gql`
    query OpusAgentTemplates {
  OpusAgentTemplates {
    id
    key
    name
    emoji
    description
    instructions
    category {
      id
      name
      index
    }
  }
}
    `;

/**
 * __useOpusAgentTemplatesQuery__
 *
 * To run a query within a React component, call `useOpusAgentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpusAgentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<OpusAgentTemplatesQuery, OpusAgentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentTemplatesQuery, OpusAgentTemplatesQueryVariables>(OpusAgentTemplatesDocument, options);
      }
export function useOpusAgentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentTemplatesQuery, OpusAgentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentTemplatesQuery, OpusAgentTemplatesQueryVariables>(OpusAgentTemplatesDocument, options);
        }
export type OpusAgentTemplatesQueryHookResult = ReturnType<typeof useOpusAgentTemplatesQuery>;
export type OpusAgentTemplatesLazyQueryHookResult = ReturnType<typeof useOpusAgentTemplatesLazyQuery>;
export type OpusAgentTemplatesQueryResult = Apollo.QueryResult<OpusAgentTemplatesQuery, OpusAgentTemplatesQueryVariables>;
export const CreateOpusAgentFromTemplateDocument = gql`
    mutation CreateOpusAgentFromTemplate($templateId: UUID!) {
  createOpusAgentFromTemplate(templateId: $templateId) {
    success
    error {
      code
      message
    }
    agent {
      ...OpusAgentFields
    }
  }
}
    ${OpusAgentFieldsFragmentDoc}`;
export type CreateOpusAgentFromTemplateMutationFn = Apollo.MutationFunction<CreateOpusAgentFromTemplateMutation, CreateOpusAgentFromTemplateMutationVariables>;

/**
 * __useCreateOpusAgentFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateOpusAgentFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpusAgentFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpusAgentFromTemplateMutation, { data, loading, error }] = useCreateOpusAgentFromTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useCreateOpusAgentFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpusAgentFromTemplateMutation, CreateOpusAgentFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpusAgentFromTemplateMutation, CreateOpusAgentFromTemplateMutationVariables>(CreateOpusAgentFromTemplateDocument, options);
      }
export type CreateOpusAgentFromTemplateMutationHookResult = ReturnType<typeof useCreateOpusAgentFromTemplateMutation>;
export type CreateOpusAgentFromTemplateMutationResult = Apollo.MutationResult<CreateOpusAgentFromTemplateMutation>;
export type CreateOpusAgentFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateOpusAgentFromTemplateMutation, CreateOpusAgentFromTemplateMutationVariables>;